export const splitArray = (array, n) => (
  array.reduce((acc, _, i) => {
    if (i % n === 0) { acc.push(array.slice(i, i + n)) }
    return acc
  }, [])
)
